import { API_BASE } from '../config';
import { getOrCreateDeviceId } from '../../helpers/device';

export type GoogleLoginResponse = {
    token: string;
    user: {
        id: string;
        email: string;
        name?: string;
        role?: string;
    };
};

// prościutki dekoder payloadu JWT (bez weryfikacji)
function decodeJwtPayload<T = any>(token: string): T | null {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json) as T;
    } catch {
        return null;
    }
}

export const loginWithGoogle = async (idToken: string): Promise<GoogleLoginResponse> => {
    const deviceId = getOrCreateDeviceId();
    const deviceName = navigator.userAgent || 'web';

    const res = await fetch(`${API_BASE}/users/login/google`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Device-Id': deviceId,
            'X-Device-Name': deviceName,
        },
        body: JSON.stringify({ id_token: idToken }),
    });

    // sparsuj raz
    let payload: any = null;
    try {
        payload = await res.json();
    } catch {
        // jeśli backend zwrócił pustą odpowiedź / nie-JSON
        throw new Error('Google login failed');
    }

    if (!res.ok) {
        // postaraj się zwrócić sensowny komunikat
        throw new Error(payload?.error || 'Google login failed');
    }

    const token: string = payload.token;
    if (!token) throw new Error('Missing token in response');

    // jeśli backend zwrócił usera — super
    let user = payload.user as GoogleLoginResponse['user'] | undefined;

    // jeśli nie — dekoduj z JWT (backend podpisuje { id, email, role })
    if (!user) {
        const p = decodeJwtPayload<{ id: string; email?: string; role?: string }>(token);
        if (p?.id) {
            user = {
                id: String(p.id),
                email: p.email || '',
                role: p.role,
            };
        }
    }

    // zapisz do storage
    localStorage.setItem('token', token);
    if (user) localStorage.setItem('user', JSON.stringify(user));

    return { token, user: user ?? { id: '', email: '' } };
};
